export default __webpack_public_path__ + "static/media/Sanitarios Portátiles1.eedfb742.png";